import React from 'react';
import { Row, Select, Space } from 'antd';
import {
	RBHBox,
	RBHCheckBox,
	RBHSelect,
	RBHSwitch,
	RBHText,
} from '../../../../../../shared/components';
import { ClockCircleOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import styleText from '../../../../../../shared/components/rbh-text/styles';
import { TIME_24 } from '../../../../../../shared/helpers/constant';
import styles from './styles';

const { Option } = Select;

interface OpenHourFormItemProps {
	dayName: string;
	isOpen: boolean;
	applyAllDay: boolean;
	startTime: string;
	endTime: string;
	onIsOpenChange: (value: boolean) => void;
	onApplyAllDayChange: (value: boolean) => void;
	onStartTimeChange: (value: string) => void;
	onEndTimeChange: (value: string) => void;
}
export const OpenHourFormItem = ({
	dayName,
	isOpen,
	applyAllDay,
	startTime,
	endTime,
	onIsOpenChange,
	onApplyAllDayChange,
	onStartTimeChange,
	onEndTimeChange,
}: OpenHourFormItemProps) => {
	return (
		<>
			<RBHBox
				style={{
					...styles.container,
					...(isOpen && styles.activeContainer),
				}}
			>
				<Space direction='vertical' size={'small'} style={styles.spaceStyle}>
					<Row justify='space-between'>
						<Row>
							<RBHSwitch
								data-testid={`id-switch-${dayName}`}
								id={`id-switch-${dayName}`}
								onChange={onIsOpenChange}
								defaultChecked={isOpen}
								size={'small'}
							/>
							<label
								style={styles.dayNameText}
								htmlFor={`id-switch-${dayName}`}
							>
								<RBHText text={dayName} style={styles.spaceDate} />
							</label>
						</Row>
						<RBHCheckBox
							checked={applyAllDay}
							onChange={(event) => onApplyAllDayChange(event.target.checked)}
							style={{ ...(!isOpen && styles.hidden) }}
						>
							<FormattedMessage id='main.branchform.openhour.time.applyallday' />
						</RBHCheckBox>
					</Row>
					{isOpen && !applyAllDay ? (
						<Row justify='space-between' style={styles.selectDateRow}>
							<>
								<RBHSelect
									className='time-dropdown'
									suffixIcon={<ClockCircleOutlined translate={null} />}
									variant='outlined'
									label={
										<FormattedMessage id='main.branchform.openhour.time.open' />
									}
									occupiedLabelStyle={styles.occupiedFloatingLabel}
									unOccupiedLabelStyle={styles.unOccupiedFloatingLabel}
									style={styles.timeDropdown}
									data-testid={`id-time-${dayName}-start`}
									id={`id-time-${dayName}-start`}
									value={startTime}
									onChange={onStartTimeChange}
								>
									{GetTimeOption()}
								</RBHSelect>
								<RBHSelect
									className='time-dropdown'
									suffixIcon={<ClockCircleOutlined translate={null} />}
									variant='outlined'
									label={
										<FormattedMessage id='main.branchform.openhour.time.close' />
									}
									occupiedLabelStyle={styles.occupiedFloatingLabel}
									unOccupiedLabelStyle={styles.unOccupiedFloatingLabel}
									style={styles.timeDropdown}
									data-testid={`id-time-${dayName}-end`}
									id={`id-time-${dayName}-end`}
									value={endTime}
									onChange={onEndTimeChange}
								>
									{GetTimeOption()}
								</RBHSelect>
							</>
						</Row>
					) : null}
				</Space>
			</RBHBox>
		</>
	);
};

const GetTimeOption = () => {
	return TIME_24.map((t, index) => {
		return (
			<Option
				style={styleText.formText}
				id={`time-${index}`}
				key={index}
				value={t}
			>
				{t}
			</Option>
		);
	});
};
